import { useQuery } from '@tanstack/react-query';
import { getActivities, getActivitySummary } from '../value.api';

export function useActivities(gln: string, params?: {
  period?: string;
  date?: string;
  page?: number;
  pageSize?: number;
}) {
  return useQuery({
    queryKey: ['value', 'activities', gln, params],
    queryFn: () => getActivities(gln, params),
    enabled: !!gln,
    staleTime: 2 * 60 * 1000,
  });
}

export function useActivitySummary(gln: string, period?: string) {
  return useQuery({
    queryKey: ['value', 'activities-summary', gln, period],
    queryFn: () => getActivitySummary(gln, period),
    enabled: !!gln,
    staleTime: 5 * 60 * 1000,
  });
}
